export class DateHelper {
  public static normalizeDateToUTC(date: Date): Date {
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
  }

  public static normalizeDateToUTCString(date: string | Date): string {
    if (!date)  {
      throw new Error('Date is required');
    }
    const d = new Date(date);

    let dateStr;

    try {
      const isoString = d.toISOString();
      dateStr = isoString.slice(0, 10);
    } catch (e) {
      console.log('Invalid date in date helper', date);
    }

    return `${dateStr}T00:00:00.000Z`;
  }

  public static normalizeDateToLocalISOString(date: string | Date): string {
    if (!date)  {
      throw new Error('Date is required');
    }
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);

    console.log(d.toISOString());
    return d.toISOString();
  }

  public static normalizeDateToDateString(date: string | Date): string {
    if (!date)  {
      throw new Error('Date is required');
    }
    const d = new Date(date);

    let dateStr;

    try {
      const isoString = d.toISOString();
      dateStr = isoString.slice(0, 10);
    } catch (e) {
      console.log('INVALID DATE IN DATE HELPER!', date);
    }

    return dateStr;
  }

  public static formatDateToLocalString(date: Date): string {
    const day = date.getDate();
    const month = date.getMonth() + 1; // Months are zero-based, so add 1
    const year = date.getFullYear();

    // console.log(day, month, year);

    // Format the date as "MM-DD-YYYY"
    // return `${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}-${year}`;

    return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  }

  public static formatDate(date: Date): string {
    return date.toISOString().slice(0, 10);
  }

  public static isValidDate(dateString) {
    const date = new Date(dateString);
    return !isNaN(date.getTime());
  }

  public static isValidDateString(dateString) {
    const date = new Date(dateString);
    if (!this.isValidDate(dateString)) {
      return false;
    }
    return dateString.match(/^\d{4}-\d{2}-\d{2}$/);
  }

  public static isSameDay(date1: Date, date2: Date) {
    return date1.getFullYear() === date2.getFullYear() &&
           date1.getMonth() === date2.getMonth() &&
           date1.getDate() === date2.getDate();
  }

  public static getDaysInMonth(month: number, year: number) {
    const date = new Date(year, month + 1, 0);
    return date.getDate();
  }

  public static getFirstDayOfMonth (month: number, year: number) {
    var firstDay = new Date(year, month, 1);
    return firstDay.getDay();
  }
}
